import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import Header from "./Sections/Header";
import Home from "./Sections/Home";
import About from "./Sections/About";
import Why from "./Sections/Why";
import Price from "./Sections/Price";
import Answers from "./Sections/Answers";
import Footer from "./Sections/Footer";
import { Routes, Route, useLocation } from "react-router-dom";
import Redirect from "./Shared/Redirect";
import TermsOfUse from "./Shared/TermOfUse";
import PrivacyPolicy from "./Shared/PrivacyPolicy";
import AccountDeletionTerms from "./Shared/AccountDeletionTerms";
import Button from "./Components/Button";
import Steps from "./Sections/Steps";
import Whatsapp from "./Sections/Whatsapp";

function App() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // remover botao começar agora do inicio no celular

  const redirect = () => {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = "/redirect";
    } else {
      // setShowQRCode(!showQRCode);
    }
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Header />
            <Home />
            <About />
            {window.innerWidth < 576 && (
              <>
                <br />
                <Button
                  onClick={() => {
                    redirect();
                  }}
                  style={{ width: "200px", margin: "0px auto 50px" }}
                >
                  Começar agora
                </Button>
              </>
            )}
            <Steps />
            <Whatsapp />
            {window.innerWidth < 576 && (
              <>
                <br />
                <Button
                  onClick={() => {
                    redirect();
                  }}
                  style={{ width: "200px", margin: "auto" }}
                >
                  Começar agora
                </Button>
              </>
            )}
            <Why />
            <Price />
            <br />
            {window.innerWidth < 576 && (
              <>
                <br />
                <Button
                  onClick={() => {
                    redirect();
                  }}
                  style={{ width: "200px", margin: "auto" }}
                >
                  Começar agora
                </Button>
              </>
            )}
            <Answers />
            <Footer />
          </>
        }
      />
      <Route
        path="/redirect"
        element={
          <>
            <Redirect />
          </>
        }
      />
      <Route
        path="/term-of-use"
        element={
          <>
            <Header />
            <TermsOfUse />
          </>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <>
            <Header />
            <PrivacyPolicy />
          </>
        }
      />
      <Route
        path="/term-delete-account"
        element={
          <>
            <Header />
            <AccountDeletionTerms />
          </>
        }
      />
    </Routes>
  );
}

export default App;
